export const mapFetchAccessControlResponse = (response) => ({
  dashboard: response.Dashboard,
  cardapio: response.Cardapio,
  minhaLoja: response.MinhaLoja,
  clientes: response.Clientes,
  cupons: response.Cupons,
  pedidos: response.Pedidos,
  replicaCardapio: response.ReplicaCardapio
});
